import React, { useContext, useState, useEffect } from 'react';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';
import { FormattedMessage, useIntl } from 'react-intl';
import ToolTip from '../../../components/shared/ToolTip/ToolTip';

const EVFilterMake = ({ vehicles }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);
  const [isVehiclesLoaded, setIsVehiclesLoaded] = useState(false);

  useEffect(() => {
    if (vehicles && vehicles.length > 0) {
      setIsVehiclesLoaded(true);
    }
  }, [vehicles]);

  if (!isVehiclesLoaded) {
    return null;
  }

  const updateMakeFilter = (e) => {
    const selectedMake = e.target.value;
    userPrefs.set({
      vehicleMakeFilter: selectedMake,
    });
  };

  const vehicleMakes = [
    ...Array.from(new Set(vehicles.map((vehicle) => vehicle.make))).sort(
      (a, b) => a.localeCompare(b)
    ),
  ];
  if (!vehicleMakes.includes('All')) {
    vehicleMakes.unshift('All');
  }

  const renderedMakeOptions = vehicleMakes.map((make) => {
    return (
      <option key={make} value={make}>
        {make}
      </option>
    );
  });

  return (
    <div className="form-group">
      <span className="label-style">
        <FormattedMessage
          id="evfilter.make"
          defaultMessage="Make"
          description="Make"
        />
      </span>
      <ToolTip
        message={
          intl.formatMessage
            ? intl.formatMessage({
                id: 'vehicleMakeTooltip',
                defaultMessage: 'Select vehicle make you are interested in.',
              })
            : 'Select vehicle make you are interested in.'
        }
        id="make_tooltip"
      />
      <div className="select-container">
        <select
          className="dropdown"
          onChange={updateMakeFilter}
          aria-label={intl.formatMessage({
            id: 'vehicleMakeDropdown',
            defaultMessage: 'Vehicle makes dropdown',
          })}
        >
          {renderedMakeOptions}
        </select>
      </div>
    </div>
  );
};

export default EVFilterMake;
